import * as React from "react";
import { Link, useLocation } from "react-router-dom";

import { SessionProps, withSession } from "../session";
import { userProfileUrl } from "../urls";

type Props = SessionProps & {
  user: {
    id: string;
    name: string;
  };
  capitalize?: boolean;
};

const UserLink = ({ me, user, capitalize }: Props): React.ReactElement => {
  const location = useLocation();
  const text =
    me && me.id === user.id ? (capitalize ? "You" : "you") : user.name;
  const element =
    (me && me.id === user.id) ||
    location.pathname.startsWith(userProfileUrl(user.id)) ? (
      <>{text}</>
    ) : (
      <Link to={userProfileUrl(user.id)}>{text}</Link>
    );
  return element;
};

export default withSession(UserLink);
